//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      imgList: {
        tabImg: require("@/common/image/course/xiabiao.png")
      },
      newList: []
    };
  },
  props: {
    tabList: {
      default: [],
      type: Array
    }
  },
  mounted() {
    this.newList = JSON.parse(JSON.stringify(this.tabList));
    this.newList[0].showActive = true;
    // this.$emit('changeTab','全部')
  },
  methods: {
    changeTab(val) {
      if (val.showActive) return;
      this.newList.forEach(item => {
        delete item.showActive;
      });
      this.$set(val, "showActive", true);
      this.$emit("changeTab", val);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/exam/tab.vue